import { Trans, useTranslation } from 'react-i18next';
import { Grid, Stack, Typography } from '@mui/material';
import { OrganizationSeatAllocation } from 'features/organizations/organizations.types';

type PurchaseSummaryKey = keyof OrganizationSeatAllocation;
type OrganizationSeatSummaryProps = {
  seats?: OrganizationSeatAllocation;
  showUsed?: boolean;
};

export const OrganizationSeatsSummary = (
  props: OrganizationSeatSummaryProps,
): JSX.Element | null => {
  const { seats, showUsed = false } = props;
  const { t } = useTranslation();

  const summaryKeys: PurchaseSummaryKey[] = ['regular', 'pro'];

  if (!seats) {
    return null;
  }

  const totals = summaryKeys.reduce(
    (acc, key) => {
      acc.purchased += seats[key].purchased;
      acc.used += seats[key].used;
      return acc;
    },
    { purchased: 0, used: 0 },
  );

  return (
    <Stack spacing={1}>
      {summaryKeys.map((key) => (
        <Grid
          container
          key={key}
          justifyContent="space-between"
          data-testid={`seat-row-${key}`}
        >
          <Typography>
            <b>{t(`organizationSeatsSummary.${key}`)}</b>
          </Typography>
          <Typography>
            {showUsed ? (
              <Trans
                i18nKey="organizationSeatsSummary.seatsTaken"
                values={seats[key]}
              />
            ) : (
              seats[key].purchased
            )}
          </Typography>
        </Grid>
      ))}
      {showUsed && (
        <Grid>
          <Typography align="right">
            <b>
              <Trans
                i18nKey="organizationSeatsSummary.seatsTaken"
                values={totals}
              />
            </b>
          </Typography>
        </Grid>
      )}
    </Stack>
  );
};
